var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { get } from '../../utils/get';
import { getEventUrl } from '../events-page/calculated/get-event-url';
import { getMainImageUrl } from '../events-page/calculated/get-main-image-url';
export var IDs = {
    DISABLE_RENDER_SCHEMA: 'events-list-component.render-schema.disable',
    SD_JSON_RENDER: 'events-list-component.structured-data.render',
};
var SchemaTypes = {
    EVENTS_LIST_COMPONENT: 'events-list-component-preset',
};
var userVisible = [];
var userVisibleSdOnly = [IDs.SD_JSON_RENDER];
var getSdStatus = function (item, data, schemaType) {
    // eslint-disable-next-line default-case
    switch (schemaType) {
        case SchemaTypes.EVENTS_LIST_COMPONENT:
            if (data[IDs.SD_JSON_RENDER] === '' || !data[IDs.SD_JSON_RENDER]) {
                return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
            }
            break;
    }
    return SD_STATUS.ENABLED;
};
var getStructuredData = function (item) {
    var events = item.events || [];
    if (!events.length) {
        return '';
    }
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: events.map(function (event, index) {
            return {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@type': 'Event',
                    name: get(event, 'title'),
                    url: getEventUrl({ event: event }),
                    image: getMainImageUrl({ event: event }),
                    offers: {
                        '@type': 'AggregateOffer',
                        highPrice: get(event, 'registration.ticketing.highestTicketPrice.amount'),
                        lowPrice: get(event, 'registration.ticketing.lowestTicketPrice.amount'),
                        currency: get(event, 'registration.ticketing.currency'),
                    },
                },
            };
        }),
    };
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a, _b;
        var data = (_a = {},
            _a[IDs.SD_JSON_RENDER] = getStructuredData(item),
            _a);
        var sdStatus = getSdStatus(item, data, SchemaTypes.EVENTS_LIST_COMPONENT) !==
            SD_STATUS.ENABLED;
        return __assign(__assign({}, data), (_b = {}, _b[IDs.DISABLE_RENDER_SCHEMA] = sdStatus, _b));
    },
    getSdStatus: getSdStatus,
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
};
